import React, { useState } from "react";
import { User, FileText, Image as ImageIcon, ArrowLeft, LoaderCircle } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";
import { decodedToken } from "../../utils/auth";
import { photomanagement } from "../../services/apiService";
import { useGlobalState } from "../../utils/GlobalState";

const Management = () => {
  const navigate = useNavigate();
  const { updateState } = useGlobalState();
  const decode = decodedToken();
  const [loading, setLoading] = useState(false);
  const userPermissions = decode?.permissions || {};
  const hasPermission = (permissionKey) => {
    return userPermissions[permissionKey] === true;
  };
  const handlePhotoManagementClick = async () => {
    try {
      setLoading(true);
      const data = await photomanagement();
      console.log("Photo Management API Response:", data);
      updateState({ photoManagement: data });
      navigate("/photomanagement");
    } catch (error) {
      console.error("Error in Photo Management click:", error.message);
    } finally {
      setLoading(false);
    }
  };

  const cards = [
    {
      title: "Account Management",
      description: "Create accounts and configure users' permissions.",
      icon: <User className="w-6 h-6 text-white" />,
      className: "",
      link: "/account-management",
      permission: "Management",
      enabled: hasPermission("Management"),
    },
    {
      title: "Template Management",
      description: "Update design change verification reference templates.",
      icon: <FileText className="w-6 h-6 text-white" />,
      link: "/templates",
      className: "hidden md:flex",
      permission: "templateManagement",
      enabled: hasPermission("templateManagement"),
    },
    {
      title: "Photo Management",
      description:
        "Provides viewing, downloading, and deleting of labeled photos with detailed...",
      icon: <ImageIcon className="w-6 h-6 text-white" />,
      className: "hidden md:flex",
      permission: "photoManagement",
      enabled: hasPermission("photoManagement"),
      onClick: handlePhotoManagementClick, 
    },
  ];

  const handleGoBack = () => {
    navigate("/dashboard");
  };

  return (
    <div className="min-h-screen bg-black text-white pt-5 relative">
      <div className="flex items-center pb-10 p-4 border-b border-gray-800 relative justify-center sm:justify-start">
        <ArrowLeft
          className="w-6 h-6 absolute left-4 sm:static sm:mr-4 cursor-pointer"
          onClick={handleGoBack}
        />
        <h1 className="text-xl gap-4 p-4 font-semibold absolute sm:static left-1/2 -translate-x-1/2 sm:translate-x-0">
          Management
        </h1>
      </div>
      {loading && (
        <div className="absolute top-1/3 left-1/2 -translate-x-1/2 z-50">
          <div className="bg-gray-800 w-70 h-70 flex flex-col items-center justify-center rounded-xl shadow-lg p-6">
            <LoaderCircle className="w-12 h-12 text-white animate-spin mb-4" />
            <p className="text-white text-base">Loading Photo Management...</p>
          </div>
        </div>
      )}

      <div className="flex flex-col gap-4 p-4">
        {cards
          .filter((card) => card.enabled)
          .map((card, index) => {
            const content = (
              <div
                className={`items-start gap-4 p-4 bg-black rounded-lg ${card.className} flex cursor-pointer hover:bg-gray-700 transition`}
                onClick={card.onClick || null}
              >
                <div className="flex p-2 rounded bg-gray-700">{card.icon}</div>
                <div>
                  <h2 className="text-base font-medium text-white">{card.title}</h2>
                  <p className="text-sm text-gray-400">{card.description}</p>
                </div>
              </div>
            );
            return card.link && !card.onClick ? (
              <Link key={index} to={card.link}>
                {content}
              </Link>
            ) : (
              <div key={index}>{content}</div>
            );
          })}
      </div>
    </div>
  );
};

export default Management;